import { render, staticRenderFns } from "./FCDetail.vue?vue&type=template&id=38fc7b60"
import script from "./FCDetail.vue?vue&type=script&lang=js"
export * from "./FCDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports